import React from 'react';

const DownloadIcon = (props: any) => {
  const { className, onClick, fillColor = '#d4d4d4' } = props;

  return (
    (<svg
      data-testid="2FNVBRdIfPFwR4dENyJLt"
      className={className}
      onClick={onClick}
      width="14px"
      height="14px"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
      data-palette="DownloadIcon">
      <g>
        <g>
          <path
            fill={fillColor}
            d="M480.6,319c-11.3,0-20.4,9.1-20.4,20.4v120.7H51.8V339.4c0-11.3-9.1-20.4-20.4-20.4c-11.3,0-20.4,9.1-20.4,20.4v141.2    c0,11.3,9.1,20.4,20.4,20.4h449.2c11.3,0,20.4-9.1,20.4-20.4V339.4C501,328.1,491.9,319,480.6,319z"
          />
          <path
            fill={fillColor}
            d="m241.6,352.7c11.1,10.7 24.4,5.2 28.9,0l124.2-124.1c8-8 8-20.9 0-28.9-8-8-20.9-8-28.9,0l-89.4,89.3v-259.2c0-11.3-9.1-20.4-20.4-20.4-11.3,0-20.4,9.1-20.4,20.4v259.1l-89.4-89.3c-8-8-20.9-8-28.9,0-8,8-8,20.9 0,28.9l124.3,124.2z"
          />
        </g>
      </g>
    </svg>)
  );
};

export default DownloadIcon;
